'use strict';

var Marionette = require('backbone.marionette');
var GroupView = require('components/remoteSites/GroupView');

module.exports = Marionette.CollectionView.extend({
  childView: GroupView,
});
